/**
 * LUNA & User Avatar Icons (Flat Design)
 * 
 * 디자인 컨셉: Ultra-Flat Minimalist
 * - LUNA: Solid Indigo (#4f46e5) + Moon Icon
 * - User: Solid Cyan (#06b6d4) + User Icon
 */
import React from 'react';

export const LunaAvatar = () => (
    <div className="w-10 h-10 rounded-full bg-indigo-600 flex items-center justify-center shrink-0 shadow-sm">
        <i className="fas fa-moon text-white text-lg"></i>
    </div>
);

export const UserAvatar = () => (
    <div className="w-10 h-10 rounded-full bg-cyan-500 flex items-center justify-center shrink-0 shadow-sm">
        <i className="fas fa-user text-black text-lg"></i>
    </div>
);
